import fileDownload from 'js-file-download';

import { makeAxiosRequest } from '@api/apiUtils';

/**
 * Функция для загрузки файла с указанного URL и сохранения его с заданным именем.
 *
 * @param {string} url - URL-адрес, с которого необходимо загрузить файл.
 * @param {string} filename - Имя файла, под которым он будет сохранен на устройстве пользователя.
 * @returns {Promise<void>} Возвращает промис, который разрешается после завершения загрузки и сохранения файла.
 *
 * @throws {Error} Исключение в случае ошибки запроса или загрузки файла.
 */
export const download = async (
  url: string,
  filename: string,
): Promise<void> => {
  try {
    const response = await makeAxiosRequest<Blob>({
      url,
      method: 'get',
      contentType: 'application/octet-stream', // Для бинарных данных
      responseType: 'blob',
    });
    return fileDownload(response, filename);
  } catch (error) {
    console.error(error);
  }
};
